// import React, { useState, useEffect } from 'react';
// import { Modal } from 'react-bootstrap';
// import { axiosInstance } from '../component/Api/instance';
// import { useNavigate } from 'react-router-dom';

// const CountdownTimer = ({ prelimsId, paperId }) => {
//     const [timeLeft, setTimeLeft] = useState(null);
//     const email = localStorage.getItem("userMail");
//     const [modalIsOpen, setModalIsOpen] = useState(false);
//     const navigate = useNavigate();

//     useEffect(() => {
//         const fetchTimeDifference = async () => {
//             try {
//                 const response = await axiosInstance.post(`post/U_PrelimsTest.php`, {
//                     id: email,
//                     prelims_id: prelimsId,
//                     paper_id: paperId,
//                 });
//                 console.log("API Response:", response.data);

//                 const serverTime = new Date(response.data.test_end); // Adjust based on API response
//                 const currentTime = new Date();

//                 if (isNaN(serverTime) || isNaN(currentTime)) {
//                     console.error("Invalid date format");
//                     return;
//                 }

//                 const timeDifference = Math.floor((serverTime - currentTime) / 1000); // Difference in seconds
//                 setTimeLeft(timeDifference > 0 ? timeDifference : 0);
//             } catch (error) {
//                 console.error("Error fetching time difference:", error);
//             }
//         };

//         fetchTimeDifference();
//     }, [paperId, prelimsId]);

//     useEffect(() => {
//         if (timeLeft === 0) {
//             setModalIsOpen(true);
//             setTimeout(() => {
//                 setModalIsOpen(false);
//                 navigate("/prelims");
//             }, 2000);
//             return;
//         }

//         const timer = timeLeft > 0 && setInterval(() => {
//             setTimeLeft(prevTime => prevTime - 1);
//         }, 1000);

//         return () => clearInterval(timer);
//     }, [timeLeft]);

//     const formatTime = (seconds) => {
//         const hrs = Math.floor(seconds / 3600);
//         const mins = Math.floor((seconds % 3600) / 60);
//         const secs = seconds % 60;
//         return `${hrs.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
//     };

//     return (
//         <div>
//             {timeLeft !== null ? (
//                 <p>TIME: {formatTime(timeLeft)}</p>
//             ) : (
//                 <p>Loading...</p>
//             )}
//             <Modal
//                 show={modalIsOpen}
//                 onHide={() => setModalIsOpen(false)}
//                 contentLabel="Times Up!"
//             >
//                 <div>
//                     <p>Times Up!</p>
//                 </div>
//             </Modal>
//         </div>
//     );
// };

// export default CountdownTimer;


import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { axiosInstance } from "../component/Api/instance";
import { useNavigate } from "react-router-dom";

const CountdownTimer = ({ prelimsId, paperId }) => {
  const [timeLeft, setTimeLeft] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const email = localStorage.getItem("userMail");
  const navigate = useNavigate();

  const localStorageKey = `prelimsTestEnd_${prelimsId}_${paperId}`;

  useEffect(() => {
    const fetchTimeDifference = async () => {
      try {
        let endTime = localStorage.getItem(localStorageKey);

        if (!endTime) {
          const response = await axiosInstance.post(`post/U_PrelimsTest.php`, {
            id: email,
            prelims_id: prelimsId,
            paper_id: paperId,
          });

          if (!response || !response.data || !response.data.test_end) {
            console.error("Invalid API response:", response);
            return;
          }

          endTime = response.data.test_end;
          localStorage.setItem(localStorageKey, endTime); // Store test end time
        }

        const serverTime = new Date(endTime);
        const currentTime = new Date();

        if (isNaN(serverTime) || isNaN(currentTime)) {
          console.error("Invalid date format");
          return;
        }

        const timeDifference = Math.floor((serverTime - currentTime) / 1000);
        setTimeLeft(timeDifference > 0 ? timeDifference : 0);
      } catch (error) {
        console.error("Error fetching time difference:", error);
      }
    };

    fetchTimeDifference();
  }, [paperId, prelimsId]);

  useEffect(() => {
    if (timeLeft === 0) {
      setModalIsOpen(true);
      setTimeout(() => {
        setModalIsOpen(false);
        localStorage.removeItem(localStorageKey); // Clear when timer ends
        navigate("/prelims");
      }, 2000);
      return;
    }

    const timer =
      timeLeft > 0 &&
      setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  const formatTime = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hrs.toString().padStart(2, "0")}:${mins
      .toString()
      .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  return (
    <div>
      {timeLeft !== null ? (
        <p>TIME: {formatTime(timeLeft)}</p>
      ) : (
        <p>Loading...</p>
      )}
      <Modal
        show={modalIsOpen}
        onHide={() => setModalIsOpen(false)}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>Time's Up</Modal.Title>
        </Modal.Header>
        <Modal.Body>Your test time has expired.</Modal.Body>
      </Modal>
    </div>
  );
};

export default CountdownTimer;
